import { NotFound } from 'modules/NotFound'
import { Navigate, Route, Routes } from 'react-router'
import { RouteParameters } from '../../../constants'
import { Schedules } from './Schedules'

const { SHOP_ID: shopId, RESOURCE_ID: resourceId } = RouteParameters

const Shops = () => (
  <Routes>
    <Route element={<Navigate replace to={`schedules`} />} path={`:${shopId}/`} />
    <Route element={<Schedules />} path={`:${shopId}/schedules/:${resourceId}/*`} />
    <Route element={<Schedules />} path={`:${shopId}/schedules/*`} />
    <Route element={<NotFound />} path="*" />
  </Routes>
)

export { Shops }
